export const getNumberValue = (param: unknown): number | null => {
  if (param !== undefined && typeof param === "string") {
    const numberString = param.trim().toLowerCase();

    if (numberString === "-infinity") {
      return -Infinity;
    } else if (numberString === "infinity") {
      return Infinity;
    } else if (!isNaN(Number(numberString))) {
      return Number(param.trim());
    }

    return null;
  } else {
    return null;
  }
};
